import { put } from "redux-saga/effects";
import { message } from "antd";
import { ApiCaller } from "../../config";
import { ProfileAction } from "../actions";

import { DefaultNotification } from "../../components";

export default class ProfileMiddleware {
  static *getUserProfile({ cb }) {
    try {
      const res = yield ApiCaller.Get("/auth/get-profile-data");
      if (res.status === 200) {
        yield put(ProfileAction.getUserProfileSuccess(res.data?.data));
      } else {
        yield put(ProfileAction.getUserProfileFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ProfileAction.getUserProfileFailure());
    }
  }

  static *editUserProfile({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put(`/auth/edit-profile-data`, payload);
      if (res.status === 200) {
        yield put(ProfileAction.editUserProfileSuccess(res.data?.data));
        DefaultNotification(res.data.message, "success", "top");
      } else {
        yield put(ProfileAction.editUserProfileFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ProfileAction.editUserProfileFailure());
    }
  }

  static *changePassword({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(`/auth/change-password`, payload);
      if (res.status === 200) {
        yield put(ProfileAction.changePasswordSuccess(res.data.data));
        DefaultNotification(
          `${res.data.message}. Login again with new credentials`,
          "success"
        );
      } else {
        yield put(ProfileAction.changePasswordFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ProfileAction.changePasswordFailure());
    }
  }
}
